import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid, IconButton } from '@mui/material';
import { Form, Formik } from 'formik';
import { useLocation } from 'react-router';
import { AddBox } from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import { getUpdateSchema } from './UpdateEventSchema';
import {
  FeedbackError,
  Input,
  Textarea,
  Button,
  CustomDatePicker,
  CustomTimePicker,
  TranslucentContainer,
  Dropdown,
  DropzoneFile,
} from '../../../../components';
import { formatDate } from '../../../../utils';
import EditEventSurchargeList from './components/EditEventSurchargeList';
import { AMENITY_SPACE_STATUS } from '../../../../constants/event-application-status';
import SpaceDimesionList from './components/SpaceDimensionList';
import * as VenuesActions from '../../../../core/venues/action';

function FormUpdateEvent({ onUpdateEvent, event }) {
  const { parameters_event: parametersEvent, vendorEvents } = event;
  const [newEventSurcharge, setNewEventSurcharge] = useState({
    name: '',
    price: '',
    status: AMENITY_SPACE_STATUS.ENABLED,
  });
  const [newSpace, setNewSpace] = useState({
    industry: '',
    size: '',
    cost: '',
    space_number: '',
    status: AMENITY_SPACE_STATUS.ENABLED,
  });
  const dispatch = useDispatch();
  const [eventSurchargeList, setEventSurchargeList] = useState([]);
  const [spaceList, setSpaceList] = useState([]);
  const [maxAllowedValue, setMaxAllowedValue] = useState(null);
  const {
    venues: { currentVenue, eventPicture },
  } = useSelector((store) => store);
  useEffect(() => {
    console.log('🍉 eventSurchargeList ', eventSurchargeList);
    console.log('🍉 spaceList ', spaceList);
  }, [eventSurchargeList, spaceList]);
  const onChangeFiles = (incomingFiles) => {
    const image = incomingFiles.filter((file) => file.valid);
    dispatch(VenuesActions.addImageToEvent(image));
  };

  useEffect(() => {
    setMaxAllowedValue(vendorEvents.length);
    if (event?.surcharges && event?.surcharges.length > 0) setEventSurchargeList(event?.surcharges);
    if (event?.space_dimensions && event?.space_dimensions.length > 0)
      setSpaceList(event?.space_dimensions);
  }, [event]);

  const validationSchema = getUpdateSchema(maxAllowedValue);

  const initialValues = {
    id: event.id,
    name: event.name,
    street_address: event.street_address,
    event_date: formatDate(parametersEvent?.event_date, 'L') || null,
    description: event.description,
    contact_name: event.contact_name,
    contact_email: event.contact_email,
    contact_phone_number: event.contact_phone_number,
    hour_start_event: parametersEvent.hour_start_event,
    hour_end_event: parametersEvent.hour_end_event,
    hour_vendor_setup_start: parametersEvent.hour_vendor_setup_start,
    hour_vendor_take_down_start: parametersEvent.hour_vendor_take_down_start,
    hour_vendor_take_down_end: parametersEvent.hour_vendor_take_down_end,
    application_deadline: formatDate(parametersEvent?.application_deadline, 'L') || null,
    max_applications: parametersEvent.max_applications,
  };

  const onSubmit = async (values, ev) => {
    const { setSubmitting } = ev;

    const result = {
      id: values.id,
      name: values.name,
      street_address: values.street_address,
      description: values.description,
      contact_name: values.contact_name,
      contact_email: values.contact_email,
      contact_phone_number: values.contact_phone_number,
      event_parameter: {
        event_date: values.event_date,
        hour_start_event: values.hour_start_event,
        hour_end_event: values.hour_end_event,
        hour_vendor_setup_start: values.hour_vendor_setup_start,
        hour_vendor_take_down_start: values.hour_vendor_take_down_start,
        hour_vendor_take_down_end: values.hour_vendor_take_down_end,
        application_deadline: values.application_deadline,
        max_applications: values.max_applications,
      },
      photo: eventPicture,
      surcharges: eventSurchargeList,
      space_dimensions: spaceList,
      venueId: currentVenue.id,
    };
    onUpdateEvent(result);
    setSubmitting(true);
  };

  const handleChangeSurcharges = (e) => {
    setNewEventSurcharge({
      ...newEventSurcharge,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeSpace = (e) => {
    setNewSpace({ ...newSpace, [e.target.name]: e.target.value });
  };

  const onDeleteSurcharge = (itemToDelete) => () => {
    setEventSurchargeList(
      eventSurchargeList.map((eventItem) =>
        eventItem.id === itemToDelete.id
          ? { ...eventItem, status: AMENITY_SPACE_STATUS.DISABLED }
          : eventItem,
      ),
    );
  };

  const onDeleteSpace = (itemToDelete) => () => {
    setSpaceList(
      spaceList.map((spaceItem) =>
        spaceItem.id === itemToDelete.id
          ? { ...spaceItem, status: AMENITY_SPACE_STATUS.DISABLED }
          : spaceItem,
      ),
    );
  };

  const addNewSurchargeEvent = () => {
    const { name, price } = newEventSurcharge;
    console.log({ newEventSurcharge });
    if (name.toString().trim() !== '' && price.trim() !== '') {
      const item = { key: uuidv4(), ...newEventSurcharge };
      setEventSurchargeList([
        ...eventSurchargeList,
        { ...item, fk_event: event.id, status: AMENITY_SPACE_STATUS.ENABLED },
      ]);
      setNewEventSurcharge({
        name: '',
        price: '',
      });
    }
  };

  const addNewSpaceEvent = () => {
    /* eslint-disable camelcase */
    const { industry, cost, size, space_number } = newSpace;
    console.log({ newEventSurcharge });
    /* eslint-disable camelcase */
    if (
      industry.toString().trim() !== '' &&
      cost.trim() !== '' &&
      size.trim() !== '' &&
      space_number.trim() !== ''
    ) {
      const item = { key: uuidv4(), ...newSpace };
      setSpaceList([
        ...spaceList,
        { ...item, fk_event: event.id, status: AMENITY_SPACE_STATUS.ENABLED },
      ]);
      setNewSpace({
        industry: '',
        cost: '',
        size: '',
        space_number: '',
      });
    }
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
        <Form
          onSubmit={handleSubmit}
          noValidate
          onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}>
          <Grid container justifyContent="space-between" marginTop={5} spacing={1}>
            <h3>Picture</h3>
          </Grid>
          <Grid container justifyContent="space-between" marginTop={5} spacing={1}>
            <Grid item xs={12} sm={12} md={11.5}>
              <DropzoneFile files={eventPicture} onChangeFiles={onChangeFiles} maxFile={1} />
            </Grid>
            Max. File 1.
          </Grid>
          <Grid container paddingLeft="10%" paddingRight="10%">
            <Grid container justifyContent="space-between" marginTop={5} spacing={1}>
              <Grid item xs={12} sm={7} marginRight={1}>
                <h3>Event Name</h3>
                <Input
                  placeholder="Event Name"
                  name="name"
                  type="text"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={errors.name && touched.name && 'error'}
                />
                <FeedbackError name="name" errors={errors} touched={touched} />
              </Grid>

              <Grid item xs={12} sm={4}>
                <h3>Event Date</h3>
                <CustomDatePicker
                  values={values}
                  errors={errors}
                  touched={touched}
                  setFieldValue={setFieldValue}
                  name="event_date"
                  placeholder="Date"
                />
                <FeedbackError name="event_date" errors={errors} touched={touched} />
              </Grid>
            </Grid>

            <Grid container justifyContent="flex-start" marginTop={1}>
              <h3>Street address</h3>
              <Grid item xs={12} sm={12} md={11.5}>
                <Input
                  placeholder="Street address"
                  name="street_address"
                  type="text"
                  value={values.street_address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={errors.street_address && touched.street_address && 'error'}
                />
                <FeedbackError name="street_address" errors={errors} touched={touched} />
              </Grid>
            </Grid>

            <Grid container justifyContent="space-between" marginTop={1} spacing={1}>
              <Grid item xs={12} sm={5} marginRight={1}>
                <h3>Application Deadline</h3>
                <CustomDatePicker
                  values={values}
                  errors={errors}
                  touched={touched}
                  setFieldValue={setFieldValue}
                  name="application_deadline"
                  placeholder="Application deadline"
                />
                <FeedbackError name="application_deadline" errors={errors} touched={touched} />
              </Grid>

              <Grid item xs={12} sm={5}>
                <h3>Max applications</h3>
                <Input
                  placeholder="Max amount of applications"
                  name="max_applications"
                  type="number"
                  value={values.max_applications}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={errors.max_applications && touched.max_applications && 'error'}
                />
                <FeedbackError name="max_applications" errors={errors} touched={touched} />
              </Grid>
            </Grid>

            <Grid container justifyContent="start" marginTop={1} xs={12} sm={12}>
              <Dropdown hidden={false} title="Event Start and Event End">
                <Grid container justifyContent="space-around">
                  <Grid item xs={12} sm={12} md={2} marginRight={3}>
                    <CustomTimePicker
                      name="hour_start_event"
                      label="Event start time"
                      value={values.hour_start_event}
                      setFieldValue={setFieldValue}
                      className={errors.hour_start_event && touched.hour_start_event && 'error'}
                    />
                    <FeedbackError name="hour_start_event" errors={errors} touched={touched} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} marginRight={3}>
                    <CustomTimePicker
                      name="hour_end_event"
                      label="Event end time"
                      value={values.hour_end_event}
                      setFieldValue={setFieldValue}
                      className={errors.hour_end_event && touched.hour_end_event && 'error'}
                    />
                    <FeedbackError name="hour_end_event" errors={errors} touched={touched} />
                  </Grid>
                </Grid>
              </Dropdown>
            </Grid>

            <Grid container justifyContent="start" marginTop={1} xs={12} sm={12}>
              <Dropdown hidden={false} title="Point of Contact">
                <Grid container justifyContent="space-evenly">
                  <Grid item xs={12} sm={4}>
                    <Input
                      name="contact_name"
                      type="text"
                      placeholder="Contact name"
                      value={values.contact_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.name && touched.name && 'error'}
                    />
                    <FeedbackError name="contact_name" errors={errors} touched={touched} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Input
                      name="contact_phone_number"
                      type="text"
                      placeholder="Contact phone number"
                      value={values.contact_phone_number}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.name && touched.name && 'error'}
                    />
                    <FeedbackError name="contact_phone_number" errors={errors} touched={touched} />
                  </Grid>

                  <Grid item xs={8}>
                    <Input
                      name="contact_email"
                      type="text"
                      placeholder="Contact email"
                      value={values.contact_email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.name && touched.name && 'error'}
                    />
                    <FeedbackError name="contact_email" errors={errors} touched={touched} />
                  </Grid>
                </Grid>
              </Dropdown>
            </Grid>

            <Grid container justifyContent="start" marginTop={1} xs={12} sm={12}>
              <Dropdown hidden={false} title="Event Setup and Take Down">
                <Grid container justifyContent="space-around">
                  <Grid item xs={12} sm={12} md={2}>
                    <CustomTimePicker
                      name="hour_vendor_setup_start"
                      label="Vendor setup begins"
                      value={values.hour_vendor_setup_start}
                      setFieldValue={setFieldValue}
                      className={
                        errors.hour_vendor_setup_start && touched.hour_vendor_setup_start && 'error'
                      }
                    />
                    <FeedbackError
                      name="hour_vendor_setup_start"
                      errors={errors}
                      touched={touched}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2}>
                    <CustomTimePicker
                      name="hour_vendor_take_down_start"
                      label="Vendor take down start"
                      value={values.hour_vendor_take_down_start}
                      setFieldValue={setFieldValue}
                      className={
                        errors.hour_vendor_take_down_start &&
                        touched.hour_vendor_take_down_start &&
                        'error'
                      }
                    />
                    <FeedbackError
                      name="hour_vendor_take_down_start"
                      errors={errors}
                      touched={touched}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2}>
                    <CustomTimePicker
                      name="hour_vendor_take_down_end"
                      label="Vendor take down end"
                      value={values.hour_vendor_take_down_end}
                      setFieldValue={setFieldValue}
                      className={
                        errors.hour_vendor_take_down_end &&
                        touched.hour_vendor_take_down_end &&
                        'error'
                      }
                    />
                    <FeedbackError
                      name="hour_vendor_take_down_end"
                      errors={errors}
                      touched={touched}
                    />
                  </Grid>
                </Grid>
              </Dropdown>
            </Grid>
            <Grid container justifyContent="center" marginTop={3}>
              <Grid item xs={12} sm={11}>
                <Textarea
                  type="text"
                  name="description"
                  placeholder="Tell us more about your event..."
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={errors.description && touched.description && 'error'}
                />
                <FeedbackError name="description" errors={errors} touched={touched} />
              </Grid>
            </Grid>

            <Grid container justifyContent="start" marginTop={1} xs={12} sm={12}>
              <Dropdown hidden={false} title="Event Surcharges">
                <Grid container justifyContent="space-between" marginTop={2}>
                  <Grid item xs={12} sm={3}>
                    <label style={{ color: 'gray', marginLeft: 5 }}> Amenity Name </label>
                    <Input
                      name="name"
                      type="text"
                      value={newEventSurcharge.name}
                      placeholder="Name"
                      onChange={handleChangeSurcharges}
                    />
                  </Grid>
                  <Grid item xs={8} sm={2}>
                    <label style={{ color: 'gray', marginLeft: 5 }}>Price </label>
                    <Input
                      name="price"
                      type="number"
                      value={newEventSurcharge.price}
                      placeholder="Price"
                      onChange={handleChangeSurcharges}
                    />
                  </Grid>
                  <Grid item xs={1} sm={1} marginLeft={5} marginTop={3}>
                    <IconButton
                      sx={{ fontSize: '80px' }}
                      color="primary"
                      component="label"
                      size="large"
                      onClick={() => addNewSurchargeEvent()}>
                      <AddBox />
                    </IconButton>
                  </Grid>
                  <Grid item sm={1} />
                </Grid>
                {eventSurchargeList.length > 0 && (
                  <EditEventSurchargeList
                    eventSurchargeList={eventSurchargeList}
                    setList={setEventSurchargeList}
                    onDelete={onDeleteSurcharge}
                    onAdd={addNewSurchargeEvent}
                  />
                )}
              </Dropdown>
            </Grid>

            <Grid container justifyContent="start" marginTop={1} xs={12} sm={12}>
              <Dropdown hidden={false} title="Space Dimensions">
                <Grid container justifyContent="space-between" marginTop={2}>
                  <Grid item xs={12} sm={2}>
                    <label style={{ color: 'gray' }}> Industry </label>
                    <Input
                      name="industry"
                      type="text"
                      value={newSpace.industry}
                      placeholder="Industry"
                      onChange={handleChangeSpace}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <label style={{ color: 'gray' }}> Size </label>
                    <Input
                      name="size"
                      type="text"
                      value={newSpace.size}
                      placeholder="Size"
                      onChange={handleChangeSpace}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <label style={{ color: 'gray' }}>Price </label>
                    <Input
                      name="cost"
                      type="number"
                      value={newSpace.cost}
                      placeholder="Price"
                      onChange={handleChangeSpace}
                    />
                  </Grid>
                  <Grid item xs={8} sm={2}>
                    <label style={{ color: 'gray' }}>Number of Spaces </label>
                    <Input
                      name="space_number"
                      type="number"
                      value={newSpace.space_number}
                      placeholder="# of Spaces"
                      onChange={handleChangeSpace}
                    />
                  </Grid>
                  <Grid item xs={1} sm={1} marginTop={3}>
                    <IconButton
                      sx={{ fontSize: '80px' }}
                      color="primary"
                      component="label"
                      size="large"
                      onClick={() => addNewSpaceEvent()}>
                      <AddBox />
                    </IconButton>
                  </Grid>
                </Grid>
                {spaceList.length > 0 && (
                  <SpaceDimesionList
                    spaceList={spaceList}
                    setList={setSpaceList}
                    onDelete={onDeleteSpace}
                    onAdd={addNewSpaceEvent}
                  />
                )}
              </Dropdown>
            </Grid>

            <Grid container justifyContent="center" marginTop={3}>
              <Grid item xs={11} sm={5}>
                <Button type="submit" label="Save" />
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default function UpdateEvent({ onUpdateEvent }) {
  const { state } = useLocation();
  return (
    <Grid container marginTop={5} justifyContent="center">
      <TranslucentContainer>
        {state?.event && <FormUpdateEvent event={state.event} onUpdateEvent={onUpdateEvent} />}
      </TranslucentContainer>
    </Grid>
  );
}

FormUpdateEvent.propTypes = {
  onUpdateEvent: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  event: PropTypes.any.isRequired,
};

UpdateEvent.propTypes = {
  onUpdateEvent: PropTypes.func.isRequired,
};
